import { render, staticRenderFns } from "./companyModal.vue?vue&type=template&id=4c6962ec"
import script from "./companyModal.vue?vue&type=script&lang=js"
export * from "./companyModal.vue?vue&type=script&lang=js"
import style0 from "./companyModal.vue?vue&type=style&index=0&id=4c6962ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports